import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-implementation',
  templateUrl: './implementation.component.html',
  styleUrls: ['./implementation.component.scss']
})
export class ImplementationComponent implements OnInit {

  utils: any;
  constructor() {
    this.utils = window.utils;
  }

  ngOnInit() {
    this.utils.init();
    window.utils.initAccesibilidad();
    window.document.body.classList.add("scroll-light-govco", "cdn-scroll-dark");
  }

}
